import Swiper, { Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'


Swiper.use([Pagination])

const projectPhotoCarousel = new Swiper('.photo-caroussel', {
  loop: true,
  spaceBetween: 20,
  slidesPerView: 1.5,
  centeredSlides: true,
  pagination: {
    clickable: true,
    el: '.photo-caroussel__pagination',
  },
})

projectPhotoCarousel


// WEBPACK FOOTER //
// ./scripts/components/projectPhotoCarousel.js